<template>
<v-app-bar
  class="px-md-4"
  color="drawer"
>
  <template #prepend>
    <v-app-bar-nav-icon
      v-if="$vuetify.display.smAndDown"
      @click="drawer = !drawer"
    />
    <nuxt-link to="/" class="logo">
    <svg-logo-text />
    </nuxt-link>
  </template>

  <template #append>
    <template v-if="$vuetify.display.mdAndUp">
      <v-btn
        v-for="{ title, to, external } in mainMenuItems"
        :key="title"
        :to="external ? undefined : to"
        :href="external ? to : undefined"
        :target="external ? '_blank' : undefined"
        :append-icon="external ? 'mdi-open-in-new' : undefined"
        class="text-none nav-link"
      >
      {{ title }}
      </v-btn>
    </template>
    <div class="saas-ask-ai-slot-nav" />

    <v-btn
      @click="localSettings.theme = localSettings.theme === 'light' ? 'dark' : localSettings.theme === 'dark' ? null : 'light'"
      :icon="localSettings.theme === 'dark' ? 'mdi-weather-night' : localSettings.theme === 'light' ? 'mdi-weather-sunny' : 'mdi-theme-light-dark'"
      :title="localSettings.theme === 'dark' ? 'Theme: Dark' : localSettings.theme === 'light' ? 'Theme: Light' : 'Theme: System'"
    />
  </template>
  <!--
  <v-btn
    class="text-none mx-6"
    color="primary"
    text="Log In"
    variant="flat"
    to="/login/"
  />
  -->
  
</v-app-bar>
<v-navigation-drawer
  v-model="drawer"
  color="drawer"
  temporary
  location="left"
  app
>
  <v-list nav>
    <v-list-item
      v-for="(item, i) in mainMenuItems"
      :key="i"
      class="nav-list-item"
      :to="item.external ? undefined : item.to"
      :href="item.external ? item.to : undefined"
      :target="item.external ? '_blank' : undefined"
      :append-icon="item.external ? 'mdi-open-in-new' : undefined"
      :active="i === 0"
      link
      :title="item.title"
    />
  </v-list>
  <div class="saas-ask-ai-slot-drawer pa-4" />
</v-navigation-drawer>
<AskAiButton teleport-to=".saas-ask-ai-slot-nav" />
<AskAiButton teleport-to=".saas-ask-ai-slot-drawer" />
</template>

<script setup lang="ts">
import { AskAiButton } from '~/chat-widget'

const drawer = ref(false)
const localSettings = useLocalSettings();

const mainMenuItems = [
  { title: 'Home', to: '/' },
  { title: 'Designs', to: '/designs' },
  { title: 'Pricing', to: '/pricing' },
  { title: 'Get license', to: '/get-license' },
  { title: 'Docs', to: 'https://docs.sysreptor.com/', external: true },
]

</script>

<style lang="scss" scoped>

.v-btn.nav-link :deep(.v-btn__append) {
  font-size: 10px;
}

.nav-link,
.nav-link:visited,
.nav-list-item,
.nav-list-item:visited,
.nav-list-item:hover {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
}

.logo,
.logo:visited {
  color: inherit;
  text-decoration: none;
}

.saas-ask-ai-slot-nav {
  display: inline-flex;
  align-items: center;
  margin-inline: 4px;
}
</style>
